import { Base } from "./model/core/base.model";
import { EpicasBean } from "./model/gestion-proyectos/epicas.model";
import { SprintBackLog } from "./sprintBackLog.model";

export class HistoriaDeUsuario extends Base{
    id: number;
    descripcion: string; 
    nombre: string;	
    como: string;; 
    necesito: string;; 
    para: string;; 
    prioridad: number;  
    riesgo: number; 
    puntos: number; 
    idEpica: number; 
    fecha_registro: Date;
    id_proyecto: number;
    criterios_aceptacion: string;
    iteracion: number;
	epica: EpicasBean;
    estatus: string;

    
}